import React from 'react'
import "./TD.scss"

function TD({ children, className }) {
  return (
    <td className={`${className} td`} style={{ minWidth: "150px", textAlign: "center", fontSize: "13px" }}>
      {children}
    </td>
  )
}

export default TD
